export default __webpack_public_path__ + "static/media/logo-ae-marina-home.7df480c7.svg";